import { jsx as e } from "react/jsx-runtime";
import r from "styled-components";
import i from "../../../utils/colors.js";
import { c as s, d as n } from "../../../styled-qu50FBLM.mjs";
import { useSidenavContext as p } from "../context.js";
const a = r.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  overflow: auto;
  ${(o) => o.$isOpen ? s : n}
  background-color: ${i.darkGrey};
`, u = () => {
  const { isOpen: o, setIsOpen: t } = p();
  return /* @__PURE__ */ e(a, { onClick: () => t(!1), $isOpen: o });
};
export {
  u as default
};
